import { useState } from "react";
import styles from "./PostPollInput.module.css";
import { useTranslation } from "react-i18next";

export default function PostPoll({ value, onChange }) {
  const { t } = useTranslation();
  const [options, setOptions] = useState(value?.options || ["", ""]);

  const handleOptionChange = (index, newValue) => {
    const updated = [...options];
    updated[index] = newValue;
    setOptions(updated);
    onChange({ options: updated });
  };

  const addOption = () => {
    if (options.length >= 4) return;
    const updated = [...options, ""];
    setOptions(updated);
    onChange({ options: updated });
  };

  const removeOption = (index) => {
    const updated = options.filter((_, i) => i !== index);
    setOptions(updated);
    onChange({ options: updated });
  };

  return (
    <div className={styles.pollContainer}>
      {options.map((opt, i) => (
        <div key={i} className={styles.optionRow}>
          <input
            type="text"
            className={styles.optionInput}
            placeholder={t("postPoll.optionPlaceholder", { number: i + 1 })}
            value={opt}
            onChange={(e) => handleOptionChange(i, e.target.value)}
          />
          {options.length > 2 && (
            <button
              type="button"
              className={styles.removeButton}
              onClick={() => removeOption(i)}
              aria-label={t("postPoll.optionPlaceholder", { number: i + 1 })}

            >
              ✕
            </button>
          )}
        </div>
      ))}

      {options.length < 4 && (
        <button type="button" className={styles.addButton} onClick={addOption}>
          {t("postPoll.addOption")}
        </button>
      )}
    </div>
  );
}
